export default "__VITE_ASSET__CG3lujUF__"